module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-wrapper"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.columns,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('table-context-menu', {
    attrs: {
      "buttons": _vm.tableButtons
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-398194f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/table_module/Table.vue
// module id = 136
// module chunks = 0